import {useEffect, useState} from 'react'
import {Button, Col, Form, Modal, Row, Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import dateformat from 'src/utils/dateformat'

interface PropsInterface {
  data: any[]
  showModal: boolean
  closeModal: () => void
}

export const DetailModal = (props: PropsInterface) => {
  const {data, showModal, closeModal} = props
  const {t} = useTranslation()

  return (
    <Modal
      show={showModal}
      onHide={() => closeModal()}
      backdrop='static'
      keyboard={false}
      centered
      size='xl'
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('Detail Log Sales Order')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='table-responsive bdr'>
          <table className='table table-striped'>
            <thead>
              <tr className='w-100 align-items-center'>
                  <th style={{ paddingLeft: '10px'}}>{t('Error ID')}</th>
                  <th>{t('Error Type')}</th>
                  <th>{t('Error Number')}</th>
                  <th>{t('Message Error')}</th>
                  <th>{t('Date')}</th>
              </tr>
            </thead>
            <tbody>
              <>
                {data.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td style={{ paddingLeft: '10px'}}>{item?.ID}</td>
                        <td>{item?.TYPE}</td>
                        <td>{item?.NUMBER}</td>
                        <td>{item?.MESSAGE}</td>
                        <td>{dateformat(item?.date as string, {showtime: true})}</td>
                      </tr>
                    )
                })}
              </>
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='primary' onClick={() => closeModal()}>
          {t('Close')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
